import {
  generalTerm,
} from '@/constants/locales/de.shared.ts';

export default {
  tabMenu: {
    view: 'Übersicht',
    alarm: 'Störungen',
    loadList: 'Chargen',
    recipe: generalTerm.recipe,
  },
};
